import {post} from '@/api'
import {SetPasswordRequest} from '@/stores'
import {AuthType} from '@/stores/change-old-password/models'
import {ENDPOINTS} from '@/constants/endpoints'

export const fetchSetPassword = (data: SetPasswordRequest, code?: number, authType?: AuthType) =>
    post<void>(ENDPOINTS.CHANGE_PASSWORD, data, getFetchSetPasswordHeaders(code, authType))

const getFetchSetPasswordHeaders = (
    code?: number,
    authType?: AuthType
): [string, string][] | undefined => {
    const headers: [string, string][] = []

    if (code) {
        headers.push(['code', `${code}`])
    }

    if (authType) {
        headers.push(['authType', authType])
    }

    return headers.length > 0 ? headers : undefined
}
